import http from 'plugins/axios'

export default {
  list(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/type/list',
      data,
    })
  },
  detail(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/type/detail',
      data,
    })
  },
  add(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/user/type/add',
      data,
    })
  },
  options() {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/type/options',
    })
  },
}
